import { Typography } from '@statsbomb/kitbag-components';
import { FilterPanel, FilterScopeProvider } from '@statsbomb/kitbag-global-football';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { COMPETITION_AVERAGE_SCOPE } from '@/consts/comparison';

export const CompetitionAverageFilterPanel = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation('radar');

  return (
    <FilterScopeProvider scope={COMPETITION_AVERAGE_SCOPE}>
      <FilterPanel>
        <Typography variant="bodyMedium" muted>
          {t('competitionAverage.helperText')}
        </Typography>
        {children}
      </FilterPanel>
    </FilterScopeProvider>
  );
};
